import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { TimePeriodUnsegmentedVizExternalProps } from '../../types';
import {
  TimePeriodUnsegmentedPieChartActions,
  TimePeriodUnsegmentedPieChartState,
} from './types';

export const useTimePeriodUnsegmentedPieChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: TimePeriodUnsegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  TimePeriodUnsegmentedPieChartState,
  TimePeriodUnsegmentedPieChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: true,
      enableStack: true,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
